
import Component from 'gia/Component';
import YouTubePlayer from 'youtube-player';
import Player from '@vimeo/player';

export default class Video extends Component {
  constructor(element) {
    super(element);
    this.options = {
      video: "0",
      type: "youtube",
      autoplay: 0,
      timestamp: 0,
      isMobile: false
    };
    this.ref = {
      play: {},
      pause: {},
      progress: {},
      progressParent: {},
      fullScreen: {}
    }
  }

  mount() {

    let that = this;
    let player;
    let videoId = this.options.video;
    let videoType = this.options.type;
    let timestamp = this.options.timestamp;
    let autoplay = this.options.autoplay;
    let controls = this.options.controls;


    if (videoType == 'youtube') {

      player = YouTubePlayer(this.element, {
        videoId: videoId,
        playerVars: {
          'rel': 0,
          'start': timestamp,
          'modestbranding': 1,
          'autoplay': autoplay,
          'controls': controls,
          'loop': autoplay,
          'playsinline': 1,
          'loop': 0,
          'muted': 1
        }
      });
      let stateNames = {
        '-1': 'unstarted',
        0: 'ended',
        1: 'playing',
        2: 'paused',
        3: 'buffering',
        5: 'video cued'
      };

      player.mute();
    } else {
      let options;
      if (autoplay) {
        options = {
          id: videoId,
          width: 800,
          controls: true,
          transcript: false,
          autoplay: autoplay,
          background: !controls,
          autopause: false,
          muted: true,
          playsinline: true,
          portrait: true
        };
      } else {
        options = {
          id: videoId,
          width: 800,
          transcript: false,
          texttrack: false,
          quality: 'auto',

          pip: false,
          keyboard: false,
          background: false,
          controls: false,
          playsinline: true
        };
      }

      player = new Player(this.element, options);
      Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(function(dimensions) {
        var width = dimensions[0];
        var height = dimensions[1];
        // let ratio = height / width * 100;

        // that.element.parentNode.style.paddingTop = ratio + '%';

        if (!autoplay) {
          player.on('play', function() {
            that.ref.play.classList.add('hidden');
            that.ref.pause.classList.remove('hidden');
            that.ref.progressParent.classList.remove('hidden');
            that.ref.fullScreen.classList.remove('hidden');

            player.on('timeupdate', function(p) {
              that.ref.progress.style.width = p.percent * 100 + '%';
            });
          });

          player.on('pause', function() {
            that.ref.pause.classList.add('hidden');
            that.ref.play.classList.remove('hidden');
          });

          that.ref.play.addEventListener('click', function() {
            player.play();
          });
          that.ref.pause.addEventListener('click', function() {
            player.pause();
          });
          that.ref.fullScreen.addEventListener('click', function() {
            if (!document.fullscreenElement) {
              // that.element.requestFullscreen();
              openFullscreen(that.element, player);

            } else {
              document.exitFullscreen();
            }

          });
          player.getDuration().then(function(duration) {
            that.ref.progressParent.addEventListener('click', function(e) {
              let percent = e.offsetX / that.ref.progressParent.offsetWidth;
              player.setCurrentTime(duration * percent);
            });
          });


        }
      });
    }
    // }

    function openFullscreen(elem, player)
    {
      //# for most browsers
      if (elem.requestFullscreen)
      { elem.requestFullscreen(); }

      //# for Safari (older versions)
      else if (elem.webkitRequestFullscreen)
      { elem.webkitRequestFullscreen(); }

      //# for Safari (newer versions)
      else if (elem.webkitEnterFullscreen)
      { elem.webkitEnterFullscreen(); }

      else {
        player.requestFullscreen();
      }
      //# for Safari iPhone (where only the Video tag itself can be fullscreen)
      // else if (elem.children[0].webkitEnterFullscreen)
      // {
      //   elem.children[0].webkitEnterFullscreen();
      //   //toggle_controls(); //# your own function to show/hide iOS media controls
      // }
      //
      // //# for Internet Explorer 11
      // else if (elem.msRequestFullscreen)
      // { elem.msRequestFullscreen(); }
    }


  }

}